import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-input-dialog',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
  ],
  templateUrl: './input-dialog.component.html',
})
export class InputDialogComponent {
  userInput: string = '';

  constructor(public ref: DynamicDialogRef) {}

  isValidEmail(): boolean {
    if (!this.userInput) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.userInput);
  }

  submit() {
    if (this.isValidEmail()) {
      this.ref.close(this.userInput);
    }
  }

  cancel() {
    this.ref.close(null);
  }
}
